module.exports = __webpack_public_path__ + "img/page8-bg-card.647af6ea.png";